import React, { Component } from "react";
import GroupCreationDisplay from "./types/GroupCreationDisplay";
import { Card } from "antd";
import CasillasDisplay from "./types/CasillasDisplay";
import LinksDisplay from "./types/LinksDisplay";
import UploadDisplay from "./types/UploadDisplay";
import TriviaDisplay from "./types/TriviaDisplay";

class ActividadIndividual extends Component {
  render() {
    const { pregunta, group, currentUser } = this.props;
    return (
      <React.Fragment>
        <Card.Meta
          style={{ padding: 10 }}
          title={pregunta.tituloActividad}
          description={pregunta.descripcionActividad}
        />
        {pregunta.tipoActividad === "transfer" && (
          <GroupCreationDisplay
            pregunta={pregunta}
            group={group}
            currentUser={currentUser}
            {...this.props}
          />
        )}
        {pregunta.tipoActividad === "casillas" && (
          <CasillasDisplay
            pregunta={pregunta}
            group={group}
            currentUser={currentUser}
            {...this.props}
          />
        )}

        {pregunta.tipoActividad === "links" && (
          <LinksDisplay
            pregunta={pregunta}
            group={group}
            currentUser={currentUser}
            {...this.props}
          />
        )}

        {pregunta.tipoActividad === "upload" && (
          <UploadDisplay
            pregunta={pregunta}
            group={group}
            currentUser={currentUser}
            {...this.props}
          />
        )}

        {pregunta.tipoActividad === "trivia" && (
          <TriviaDisplay
            pregunta={pregunta}
            group={group}
            currentUser={currentUser}
            {...this.props}
          />
        )}
      </React.Fragment>
    );
  }
}

export default ActividadIndividual;
